import http from '@/helpers/Http';

export default {
    namespaced: true,
    state: {
        items: {
            data: [],
            links: {},
            meta: {},
        },
        selected: {},
    },
    getters: {
        items: state => state.items,
        selected: state => state.selected,
    },
    mutations: {
        setItems(state, items) {
            state.items = items;
        },
        setSelected(state, selected) {
            state.selected = selected;
        },
    },
    actions: {
        async index({ commit, rootState }, payload) {
            const response = await http.get('wideband/tickets', {params: Object.assign(rootState.route.query, payload)});

            commit('setItems', response.data);

            return response;
        },
        async clearance({ commit, state }, payload) {
            const response = await http.post(`wideband/tickets/${state.selected.id}/clearance`, payload);

            commit('setSelected', response.data);

            return response;
        },
        async sync({ commit }, type) {
            const response = await http.get('wideband/tickets/sync', {
                params: {type}
            });

            commit('setItems', response.data);

            return response;
        }
    }
}